import {KeyboardArrowDown, KeyboardArrowUp, Search as SearchIcon} from "@mui/icons-material";
import React, {useState} from "react";
import {alpha, Box, IconButton, InputBase, styled, Typography} from "@mui/material";

const Search = styled('div')(({ theme }) => ({
    display: "flex",
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(3),
        width: 'auto',
    },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 1),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 5),
        // vertical padding + font size from searchIcon
        transition: theme.transitions.create('width')
    },
}));

interface IProps {
    index?: number
    count?: number
    searchText: (text: string) => void
    searchUp?: () => void
    searchDown?: () => void
}
export default function SearchTool({index, count, searchText, searchUp, searchDown}: IProps) {
    const [search, setSearch] = useState("");
    const handleSearchChange = ({currentTarget}: React.ChangeEvent<HTMLInputElement>) => {
        setSearch(currentTarget.value);
    };
    const handleSearchKeyPress = ({key}: React.KeyboardEvent<HTMLImageElement>) => {
        if (key === "Enter") {
            searchText(search);
        }
    };
    const handleClickUp = () => {
        searchUp && searchUp();
    }
    const handleClickDown = () => {
        searchDown && searchDown();
    }

    return (
        <Search>
            <SearchIconWrapper>
                <SearchIcon/>
            </SearchIconWrapper>
            <StyledInputBase
                placeholder="Search…" inputProps={{"aria-label": "search"}} value={search}
                onChange={handleSearchChange} onKeyPress={handleSearchKeyPress}/>
            {count !== undefined && index !== undefined && count > 0 &&
                <Box display="inline-flex" marginRight={1} alignItems="center">
                    <Typography variant="caption" >{`${index + 1}/${count}`}</Typography>
                    <IconButton onClick={handleClickUp} color="inherit" size="small" disableRipple>
                        <KeyboardArrowUp/>
                    </IconButton>
                    <IconButton onClick={handleClickDown} color="inherit" size="small" disableRipple>
                        <KeyboardArrowDown/>
                    </IconButton>
                </Box>}
        </Search>
    );
}